/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Slim_Swan_GulpInputs */

const en_gray_slim_swan_gulp = /** @type {(inputs: Gray_Slim_Swan_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Round override`)
};

const de_gray_slim_swan_gulp = /** @type {(inputs: Gray_Slim_Swan_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runden-Überschreibung`)
};

/**
* | output |
* | --- |
* | "Round override" |
*
* @param {Gray_Slim_Swan_GulpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_slim_swan_gulp = /** @type {((inputs?: Gray_Slim_Swan_GulpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Slim_Swan_GulpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_slim_swan_gulp(inputs)
	return de_gray_slim_swan_gulp(inputs)
});